<!-- Lineref, Content & Quantity  -->
<div class="material-lines-panel" *ngIf="materials.length > 0">
  <h3>{{ 'CCR.DETAILS.' + titlePart | translate }}</h3>

  <div class="row cell headings hide-xs">
    <div class="col-md sorter" sortable-header='packingId' [sortField]="filter?.sortField" [sortAscending]="filter?.sortAscending" [sortFn]="changeSortBnd">
      {{ 'ORDERS.MATERIAL.LABELS.PACKING' | translate }}
    </div>
    <div class="sorter col-md" sortable-header='lineReferenceId' [sortField]="filter?.sortField" [sortAscending]="filter?.sortAscending" [sortFn]="changeSortBnd">
      {{ 'ORDERS.MATERIAL.LABELS.LINE_REFERENCE' | translate }}
    </div>
    <div class="col-md">
      {{ 'ORDERS.MATERIAL.LABELS.CONTENT' | translate }}
    </div>
    <div class="col-md small-col" *ngIf="!panelStatus.showQuantityOriginalAndDefinitive">
      {{ 'ORDERS.MATERIAL.LABELS.QTY' | translate }}
    </div>
    <div class="col-md small-col" *ngIf="panelStatus.showQuantityOriginalAndDefinitive">
      {{ 'FLOWS.LIST.LABELS.ORIGINAL' | translate }}
    </div>
    <div class="col-md small-col" *ngIf="panelStatus.showQuantityOriginalAndDefinitive">
      {{ 'FLOWS.LIST.LABELS.DEFINITIVE' | translate }}
    </div>
    <div class="col-md small-col" *ngIf="panelStatus.showQuantityDifference">
      {{ 'FLOWS.LIST.LABELS.DIFFERENCE' | translate }}
    </div>
    <div class="col-md small-col"  *ngIf="panelStatus.showSaldoColumn">
      {{ 'FLOWS.LIST.LABELS.SALDO' | translate }}
    </div>
    <div class="col-md">
      <!-- for edit fields -->
    </div>
  </div>

  <div class="hr-accent no_margin_bottom hide-xs"></div>

  <div *ngFor="let material of materials; index as i" class="striped" [ngClass]="{ readonly: !panelStatus.isEdit }">
    <div class="material_line" *ngIf="material.type === 'packing' || material.type === 'combination' || true">
      <div class="col-md packingType">
        <eps-select
          [options]="definitions.packing.type"
          [value]="material.packingId"
          readonly
          label="ORDERS.MATERIAL.LABELS.PACKING"
          [labelPosition]="labelPosition"
        ></eps-select>
      </div>
      <div class="col-md" *ngIf="!isMobile || material.lineReferenceId">
        <eps-label-body
          label="ORDERS.MATERIAL.LABELS.LINE_REFERENCE"
          [labelPosition]="labelPosition"
          *ngIf="material.lineReferenceId"
        >
          {{ material.lineReferenceId }}
        </eps-label-body>
      </div>
      <div class="col-md" *ngIf="!isMobile || material.contentId">
        <eps-label-body
          label="ORDERS.MATERIAL.LABELS.CONTENT"
          [labelPosition]="labelPosition"
          *ngIf="material.contentId"
        >
          {{ getContent(material.contentId) }}
        </eps-label-body>
      </div>
      <div class="col-md small-col small-col-padding" *ngIf="(!isMobile || isNumeric(material.packingQuantity)) && !panelStatus.showQuantityOriginalAndDefinitive">
        <eps-label-body
          label="ORDERS.MATERIAL.LABELS.QTY"
          [labelPosition]="labelPosition"
        >
          {{ material.packingQuantity }}
        </eps-label-body>
      </div>
      <div class="col-md small-col small-col-padding" *ngIf="(!isMobile || isNumeric(material.originalQuantity)) && panelStatus.showQuantityOriginalAndDefinitive">
        <eps-label-body
          label="FLOWS.LIST.LABELS.ORIGINAL"
          [labelPosition]="labelPosition"
        >
          {{ material.originalQuantity }}
        </eps-label-body>
      </div>
      <div class="col-md small-col small-col-padding" *ngIf="(!isMobile || isNumeric(material.definitiveQuantity)) && panelStatus.showQuantityOriginalAndDefinitive">
        <eps-label-body
          label="FLOWS.LIST.LABELS.DEFINITIVE"
          [labelPosition]="labelPosition"
        >
          <div class="definitive-quantity">
            <span [ngClass]="{ strikethrough: showDisputeQuantity(material) }">{{ material.definitiveQuantity }}</span>
            <span *ngIf="showDisputeQuantity(material)">{{ material.disputeQuantity }}</span>
          </div>
        </eps-label-body>
      </div>
      <div class="col-md small-col small-col-padding" *ngIf="(!isMobile || isNumeric(material.difference)) && panelStatus.showQuantityDifference">
        <eps-label-body
          label="FLOWS.LIST.LABELS.DIFFERENCE"
          [labelPosition]="labelPosition"
        >
          {{ material.difference }}
        </eps-label-body>
      </div>
      <div class="col-md small-col small-col-padding"  *ngIf="(!isMobile || material.saldo) && panelStatus.showSaldoColumn">
        <eps-label-body
          label="FLOWS.LIST.LABELS.SALDO"
          [labelPosition]="labelPosition"
        >
          {{ material.saldo }}
        </eps-label-body>
      </div>
      <div class="col-md icon-buttons">
        <div *ngIf="panelStatus.isEdit">
          <i class="fa fa-2x fa-pencil edit hand" aria-hidden="true" *ngIf="material.isEditable" (click)="editMaterial(material)"></i>
          <i class="fa fa-2x fa-trash-o remove hand" aria-hidden="true" *ngIf="canRemoveMaterial(material)" (click)="removeMaterialClicked.emit(material)"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="hr-accent"></div>
</div>
